// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e_2D","left":"styles_left__3a6m1","desktopActions":"styles_desktopActions__HN4hV","title":"styles_title__3z69e"};